export enum CompanyAdminNameOptionType {
  email = 'Email',
  name = 'Name',
}
